import ax from './ax';
import axManage from './axManage';

// 获取图片上传接口
export function GetImageUploadUrl(data = {}) {
  return ax({
    url: '/app/Customer/GetImageUploadUrl',
    method: 'post',
    data,
  });
}

// 查询当前登录代理商费率
export function GetCurrentAgentFee(data = {}) {
  return ax({
    url: '/app/Customer/GetCurrentAgentFee',
    method: 'post',
    data,
  });
}

// 获取行业列表（需调用3次，第一次传0，此后传返回的pid）
export function GetBusinessList(data = {}) {
  return ax({
    url: '/app/Customer/GetBusinessList',
    method: 'post',
    data,
  });
}

// 代理商商户进件审核（新增数据）
export function InsertNewCustomerData(data = {}) {
  return ax({
    url: '/app/Customer/InsertNewCustomerData',
    method: 'post',
    data,
  });
}

// 商户进件编辑
export function EditCustomerData(data = {}) {
  return ax({
    url: '/app/Customer/EditCustomerData',
    method: 'post',
    data,
  });
}

// 查询商户进件列表（查看列表）
export function QueryCustomerList(data = {}) {
  return ax({
    url: '/app/Customer/QueryCustomerList',
    method: 'post',
    data,
  });
}

// 查看商户信息(包括审核进度)
export function QueryCustomerDetails(data = {}) {
  return ax({
    url: '/app/Customer/QueryCustomerDetails',
    method: 'post',
    data,
  });
}

// 获取短链接
export function GetShortUrl(data = {}) {
  return ax({
    url: '/app/Customer/GetShortUrl',
    method: 'post',
    data,
  });
}

// 上传协议书匿名获取信息（协议编号和费率）
export function GetCustomerNumber(data = {}) {
  return axManage({
    url: '/api/Customer/GetCustomerNumber',
    method: 'post',
    data,
  });
}

// 提交协议照片
export function UploadAuthCommitmentPicUrl(data = {}) {
  return axManage({
    url: '/api/Customer/UploadAuthCommitmentPicUrl',
    method: 'post',
    data,
  });
}

// 查询省/市/区（需调用3次，第一次传0，此后传返回的pid）
export function GetAreaList(data = {}) {
  return ax({
    url: '/api/SysData/getAreaList',
    method: 'post',
    data,
  });
}

// 获取全部银行名称
export function GetAllBankName(data = {}) {
  return ax({
    url: '/app/Bank/GetAllBankName',
    method: 'post',
    data,
  });
}

// 获取银行卡支持的省份列表
export function GetBankProvinceName(data = {}) {
  return ax({
    url: '/app/Bank/GetBankProvinceName',
    method: 'post',
    data,
  });
}

// 获取银行卡支持的城市列表
export function GetBankCityName(data = {}) {
  return ax({
    url: '/app/Bank/GetBankCityName',
    method: 'post',
    data,
  });
}

// 根据省、市、总行名称查询分行
export function GetBankName(data = {}) {
  return ax({
    url: '/app/Bank/GetBankName',
    method: 'post',
    data,
  });
}

// 识别用户身份证信息(百度)
export function GetIdCardInformation(data = {}) {
  return ax({
    url: '/app/User/GetIdCardInformation',
    method: 'post',
    data,
  });
}

// 识别用户银行卡信息(百度)
export function GetBankCardInformation(data = {}) {
  return ax({
    url: '/app/User/GetBankCardInformation',
    method: 'post',
    data,
  });
}

// 加机（绑定收款码)
export function AddPayTagExt(data = {}) {
  return ax({
    url: '/app/Terminal/AddPayTagExt',
    method: 'post',
    data,
  });
}

// 获取开通微信二维码
export function GetWeChatMerchantMsg(data = {}) {
  return ax({
    url: '/api/Customer/GetWeChatMerchantMsg',
    method: 'post',
    data,
  });
}

// 获取开通支付宝二维码，2022.8.12
export function GetAliPayMerchantMsg(data = {}) {
  return ax({
    url: '/api/Customer/GetAliPayMerchantMsg',
    method: 'post',
    data,
  });
}

// 根据银行卡号返回清算行信息
export function GetSBNOByCardNum(data = {}) {
  return ax({
    url: '/app/Bank/GetSBNOByCardNum',
    method: 'post',
    data,
  });
}

// 根据银行卡号返回清算行信息
export function GetSBNOByCardNumWithoutLogin(data = {}) {
  return ax({
    url: '/app/Bank/GetSBNOByCardNumWithoutLogin',
    method: 'post',
    data,
  });
}

// 根据银行卡号返回清算行信息
export function SendCustomerNotification(data = {}) {
  return ax({
    url: '/app/Customer/SendCustomerNotification',
    method: 'post',
    data,
  });
}

// 根据银行卡号返回清算行信息
export function GetBusinessLicenseInfo(data = {}) {
  return ax({
    url: '/app/User/GetBusinessLicenseInfo',
    method: 'post',
    data,
  });
}

// 生成一个唯一的协议编号
export function GenerateAuthNum(data = {}) {
  return ax({
    url: '/app/Customer/GenerateAuthNum',
    method: 'post',
    data,
  });
}

// 重新注册电子协议
export function ResendEAgreement(data = {}) {
  return ax({
    url: '/app/Customer/ResendEAgreement',
    method: 'post',
    data,
  });
}

// 新增进件-数据缓存
export function InsertCustomerCache(data = {}) {
  return ax({
    url: '/app/Customer/InsertCustomerCache',
    method: 'post',
    data,
  });
}

// 新增进件-数据缓存
export function GetCustomerCache(data = {}) {
  return ax({
    url: '/app/Customer/GetCustomerCache',
    method: 'post',
    data,
  });
}

// 向服务器获取活体识别关键信息
export function GetOcrToken(data = {}) {
  return ax({
    url: '/app/Customer/GetOcrToken',
    method: 'post',
    data,
  });
}

// 商户进件-上传面部检测数据或手持身份证照片(H5)
export function UpdateFaceDetectionData(data = {}) {
  return ax({
    url: '/app/Customer/UpdateFaceDetectionData',
    method: 'post',
    data,
  });
}

// 商户进件-查询数据是否在黑名单中
export function QueryBlacklist(data = {}) {
  return ax({
    url: '/app/Customer/QueryBlacklist',
    method: 'post',
    data,
  });
}

// 商户进件-查询黑名单
export function QueryCustomerBlacklist(data = {}) {
  return ax({
    url: '/app/Customer/QueryCustomerBlacklist',
    method: 'post',
    data,
  });
}

// 商户进件-查询黑名单
export function GetBusinessTreeListAsSecondary(data = {}) {
  return ax({
    url: '/app/Customer/GetBusinessTreeListAsSecondary',
    method: 'post',
    data,
  });
}

// 商户进件-查询当前身份证号注册数量是否超限
export function IsReachedMaximumLimitByIdCardNum(data = {}) {
  return ax({
    url: '/app/Customer/IsReachedMaximumLimitByIdCardNum',
    method: 'post',
    data,
  });
}

// 商户进件-校验当前公司名称是否合法
export function IsLegitimacyForCompanyName(data = {}) {
  return ax({
    url: '/app/Customer/IsLegitimacyForCompanyName',
    method: 'post',
    data,
  });
}

// 传入一个营业执照开始时间，判断能否进件，格式yyyyMMdd
export function BusinessStartDateParse(data = {}) {
  return ax({
    url: '/app/Customer/BusinessStartDateParse',
    method: 'post',
    data,
  });
}

// 商户进件-校验当前公司所在区域是否合法
export function IsLegitimacyForCompanyArea(data = {}) {
  return ax({
    url: '/app/Customer/IsLegitimacyForCompanyArea',
    method: 'post',
    data,
  });
}

// 商户进件-校验公司地址是否合法
export function IsLegitimacyForCompanyAddress(data = {}) {
  return ax({
    url: '/app/Customer/IsLegitimacyForCompanyAddress',
    method: 'post',
    data,
  });
}

// 自助注册邀请码列表
export function QueryCustomerInviteCodeList(data = {}) {
  return ax({
    url: '/app/Customer/QueryCustomerInviteCodeList',
    method: 'post',
    data,
  });
}

// 添加/修改/删除 自助注册邀请码
export function ModifiedCustomerInviteCode(data = {}) {
  return ax({
    url: '/app/Customer/ModifiedCustomerInviteCode',
    method: 'post',
    data,
  });
}// 商户进件-查询自身是否有进件权限
export function QueryCustomerPermission(data = {}) {
  return ax({
    url: '/app/Customer/QueryCustomerPermission',
    method: 'post',
    data,
  });
}

// 商户进件-第三方计费统计入库（免登陆）
export function RecordThridSpendLog(data = {}) {
  return ax({
    url: '/app/Customer/RecordThridSpendLog',
    method: 'post',
    data,
  });
}

// 商户进件-查询所有可用的地区列表
export function GetAreaListAsTree(data = {}) {
  return axManage({
    url: '/api/SysData/GetAreaListAsTree',
    method: 'post',
    data,
  });
}

// 2022.9.22 业务员模块-业务员管理
export function GetXHZSSalesmanList(data = {}) {
  return ax({
    url: '/app/Customer/GetXHZSSalesmanList',
    method: 'post',
    data,
  });
}

// 2022.9.22 业务员模块-业务员详情
export function GetXHZSSalesmanOne(data = {}) {
  return ax({
    url: '/app/Customer/GetXHZSSalesmanOne',
    method: 'post',
    data,
  });
}

// 2022.9.22 业务员模块-新增业务员
export function InsertSalesman(data = {}) {
  return ax({
    url: '/app/Customer/InsertSalesman',
    method: 'post',
    data,
  });
}

// 2022.9.22 业务员模块-编辑业务员-重置密码
export function UpdateSalesmanPassWord(data = {}) {
  return ax({
    url: '/app/Customer/UpdateSalesmanPassWord',
    method: 'post',
    data,
  });
}

// 2022.9.22 业务员模块-编辑业务员-更改角色等级
export function UpdateSalesmanType(data = {}) {
  return ax({
    url: '/app/Customer/UpdateSalesmanType',
    method: 'post',
    data,
  });
}

// 2022.9.22 业务员模块-获取账号角色列表
export function GetSalesmanType() {
  return ax({
    url: '/app/Customer/GetSalesmanType',
    method: 'post',
  });
}

// 2022.11.10 流量费明细
export function GetDeductionMoneyPlanList(data = {}) {
  return ax({
    url: '/api/Terminal/getDeductionMoneyPlanList',
    method: 'post',
    data,
  });
}

// 2023.2.14
export function GetTemporaryTokenByWeChatId(data = {}) {
  return ax({
    url: '/app/Customer/GetTemporaryTokenByWeChatId',
    method: 'post',
    data,
  });
}

// 2023.2.20
export function GetH5SMSCode(data = {}) {
  return ax({
    url: '/app/User/GetH5SMSCode',
    method: 'post',
    data,
  });
}

// 2023.2.20
export function GetCollectTypeForCustomer(data = {}) {
  return ax({
    url: '/app/Customer/GetCollectTypeForCustomer',
    method: 'post',
    data,
  });
}

